import { authentication } from './authentication';

export default authentication;

export const authDefaultState = {
  
}


// WEBPACK FOOTER //
// ./src/authentication/javascripts/reducers/index.js